import { render, staticRenderFns } from "./PersonTaskSum.vue?vue&type=template&id=3f70c4b8&scoped=true"
import script from "./PersonTaskSum.vue?vue&type=script&lang=js"
export * from "./PersonTaskSum.vue?vue&type=script&lang=js"
import style0 from "./PersonTaskSum.vue?vue&type=style&index=0&id=3f70c4b8&prod&scoped=true&lang=css"
import style1 from "./PersonTaskSum.vue?vue&type=style&index=1&id=3f70c4b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f70c4b8",
  null
  
)

export default component.exports